// extracted by mini-css-extract-plugin
module.exports = {"container":"AbonnementBuy_container__b1Lo7","button":"AbonnementBuy_button__1rnk3","mobile":"AbonnementBuy_mobile__2Sorq","favorite":"AbonnementBuy_favorite__2RpLo"};